import { render, staticRenderFns } from "./MainMenu.1.vue?vue&type=template&id=619d6f92&scoped=true&"
import script from "./MainMenu.1.vue?vue&type=script&lang=js&"
export * from "./MainMenu.1.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.1.vue?vue&type=style&index=0&id=619d6f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d6f92",
  null
  
)

export default component.exports